import { OTP_CONFIG } from '@porterin/booking-flow/src/auth/domain/config/otp';
import { AuthTexts } from '@porterin/booking-flow/src/auth/view/stores/AuthStore';
import { z as zod } from 'zod';

export const otpFormSchema = zod.object({
  otp: zod.string().length(OTP_CONFIG.MAX_CHAR_LENGTH, AuthTexts.otpInvalid),
});

export type OtpFormValues = zod.infer<typeof otpFormSchema>;
